export default __webpack_public_path__ + "static/media/ss-readme-generator.a69c939e.png";